import {
  ElvaFederatedChatHost,
  ensureElvaFederationHostBridge,
} from '@elva/ai-chat';
import { getAppConfig, getStoredToken, useAuthStore } from '@elva/platform';

let bridgeInitialized = false;

/** Call after PlatformProvider has run initPlatformApi (e.g. from AppLayout). */
export function initAiAssistantBridge() {
  if (bridgeInitialized) return;
  bridgeInitialized = true;

  const extraLegacy = import.meta.env.VITE_FEDERATION_REMOTE_ACCOUNT_ORIGIN?.trim();

  ensureElvaFederationHostBridge({
    getAccessToken: () =>
      useAuthStore.getState().accessToken ?? getStoredToken(),
    getAccountApiBaseUrl: () => getAppConfig().accountApiUrl,
    ...(extraLegacy ? { extraLegacyAccountApiBases: [extraLegacy] } : {}),
  });
}

export { ElvaFederatedChatHost };
